const { Record } = require('immutable');

const InitialState = Record({
  detail: {},
  outColor: [],

  // 申请材料相关
  applicationDownloadInfo: [],
  applicationMaterialList: [],

  //  交车材料相关
  dealDownloadInfo: [],
  pickupMaterialList: [],

  // 请款材料
  requestMaterialList: [],
  requestFundsDownloadInfo: [],

  // 放款材料
  loanMaterialList: [],
  loanDownloadInfo: [],

  // 收益信息:
  profitDetail: {},

  // 保险信息
  insuranceCompanys: [],
  insuranceListMap: new Map(),
  insuranceConfigMap: new Map(),
  insuranceDetail: {},

  // 客户信息
  customerDetail: {},

  // 操作日志
  operateLogs: [],
});

export default InitialState;

